import { SideNavHeader } from "@/SideNavDashboards/SideNavHeader/SideNavHeader";
import { useAppSession } from "@/auth/AppSessionContext";
import { Dashboards } from "@/dashboard";

interface SideNavDashboardsProps {
  showCustomLogo?: boolean;
}

export const SideNavDashboards: React.FC<SideNavDashboardsProps> = ({ showCustomLogo }: SideNavDashboardsProps) => {
  const { sessionActivated } = useAppSession();
  return (
    <>
      <SideNavHeader showCustomLogo={showCustomLogo} />
      {sessionActivated && <Dashboards maximized={true} allowCollapse={true} isSideNav={true} />}
    </>
  );
};
